import React from 'react';
import idcardcss from '../pages/css/idcard.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { savefocusoftheday } from '../dbconnector/connector'
import { setErrorMessage } from "../tools/errorhandling";
import { CgCloseR } from "react-icons/cg";
import Button from 'react-bootstrap/Button';



const FocusOfTheDay = ({ rights, t, hotelid, date, events }) => {

     useEffect(() => {
        document.getElementById("focusdescription").value = sessionStorage.getItem('FocusOfTheDay_'+hotelid+"_"+date)
    }, []);

    useEffect(() => {
        document.getElementById("focusdescription").value = sessionStorage.getItem('FocusOfTheDay_'+hotelid+"_"+date)
    }, [hotelid, date]);

    const saveFocusText = (e) => {
         sessionStorage.setItem('FocusOfTheDay_'+hotelid+"_"+date, document.getElementById("focusdescription").value)
         events.handleCancel()
    }

    return (
        <div id="focusOftheDay" className='focusOfTheDay'>
            <div className='formcaption' onMouseDown={(e)=>events.startdrag("focusOftheDay", true,e)} onMouseUp={(e)=>events.startdrag(null, false,e)}>{t('AddGeneralTask')}<CgCloseR className='closer' onClick={events.handleCancel} /></div>
            <div className="AssignCleaningform">
                <label className='labelhotel'>
                    {t('Omschrijving')}
                </label>
                <textarea id="focusdescription" name="title" className="doublegrid" type='text'>
                </textarea>
                &nbsp;
                <div className='messageBoxes'>
                    <Button type="button" id="CloseMessageButton" className="OkCancel messageBoxAlignRight" onClick={saveFocusText}>{t("OK")}</Button>
                    <Button type="button" id="CancelMessageButton" className="OkCancel messageBoxAlignleft" onClick={events.handleCancel}>{t("Cancel")}</Button>
                </div>
            </div>

        </div>
    );
};


export default FocusOfTheDay;
